import PropTypes from 'prop-types'

export const MediaContent = ({
  type = 'image',
  src,
  alt,
  caption,
  autoPlay = false,
  loop = false,
  muted = true,
  controls = true,
}) => (
  <div className="my-6">
    {caption && <p className="text-sm text-gray-400 mb-2">{caption}</p>}

    {type === 'image' ? (
      <img
        src={src}
        alt={alt}
        className="w-full rounded-lg border border-dark-border"
        onError={(e) => {
          e.target.style.display = 'none'
          e.target.parentElement.innerHTML = `
            <div class="w-full h-64 bg-dark-secondary rounded-lg border border-dark-border flex items-center justify-center">
              <span class="text-gray-500">Image placeholder</span>
            </div>
          `
        }}
      />
    ) : (
      <div className="w-full bg-black rounded-lg border border-dark-border overflow-hidden">
        <video
          className="w-full"
          autoPlay={autoPlay}
          loop={loop}
          muted={muted}
          controls={controls}
          playsInline
          controlsList="nodownload"
        >
          <source src={src} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    )}
  </div>
)

MediaContent.propTypes = {
  type: PropTypes.oneOf(['image', 'video']),
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  caption: PropTypes.string,
  autoPlay: PropTypes.bool,
  loop: PropTypes.bool,
  muted: PropTypes.bool,
  controls: PropTypes.bool,
}

export default MediaContent
